import { yupResolver } from "@hookform/resolvers/yup";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Checkbox as MUICheckbox,
  Tabs,
  Tab,
  Box, Paper,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Grid,
  TextField,
  InputAdornment
} from "@mui/material";

import { useStoreActions, useStoreState } from "easy-peasy";
import * as React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Autocomplete, FileListField, Select, DateField }
  from "../../components";
import api from "../../services/api";
import { tiposCargas, tiposServicos, deparaTecnologiasSistemasTomadaPreco, deparaServicosSistemasTomadaPreco, tituloTabelaAddTomadaPorCarga, dialogoTomadaPreco } from "../../static";
import { formatCurrency } from "../../services/utils";

//import ViewTomadaPrecoFaseOneHeader from "../../components/TomadaPreco/ViewTomadaPrecoFaseOneHeader";
//import ViewTomadaPrecoFaseOneBody from "../../components/TomadaPreco/ViewTomadaPrecoFaseOneBody";

import PropTypes from 'prop-types';
import { ConstructionOutlined } from "@mui/icons-material";

import '../StepPreDiagnosticoRelatorios/ModalRelResumo.css';
import { useState } from "react";
import { set } from "date-fns";
import { useEffect } from "react";
import { is } from "date-fns/locale";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;



const DialogoAcompanhaOrcamentosFaseOne = ({ open, onClose, orcamento, itens, isFornecedor = false }) => {
  let loading = useStoreState((state) => state.nav.loading);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let currProcesso = useStoreState((state) => state.processo.current);

  const [dados, setDados] = React.useState();
  const [somaTotal, setSomaTotal] = React.useState(0);
  const [data, setData] = useState(itens?.data || []);
  const [rows, setRows] = React.useState(itens?.data || []);
  const [totalSumFontes, setTotalSumFontes] = React.useState(0);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isErrorValidadeProposta, setIsErrorValidadeProposta] = React.useState(false);
  const [isErrorPrazo, setIsErrorPrazo] = React.useState(false);
  // const [isPastDate, setIsPastDate] = React.useState(null);

  const prazoEncerrado = React.useMemo(() => {
    if (!orcamento?.finishedAt) return false;
    const prazo = new Date(orcamento.finishedAt);
    return !Number.isNaN(prazo.getTime()) && prazo.getTime() < Date.now();
  }, [orcamento?.finishedAt]);

  const getSlugForIds = (tecnologiaId, servicoId) => {
    if (tecnologiaId) {
      for (const [slug, arr] of Object.entries(deparaTecnologiasSistemasTomadaPreco)) {
        if (arr.some(item => item.A === tecnologiaId)) {
          return slug;
        }
      }
    }
    if (servicoId) {
      for (const [slug, arr] of Object.entries(deparaServicosSistemasTomadaPreco)) {
        if (arr.some(item => item.S === servicoId)) {
          return slug;
        }
      }
    }
    return null;
  };

  const resolveSlugForRow = (row) => {
    const opt = row.orcamentoProcessoTipo || row.orcamento_processo_tipo;
    if (opt) {
      const slug = getSlugForIds(opt.tecnologiaId || opt.tecnologia_id, opt.servicoId || opt.servico_id);
      if (slug) return slug;
    }
    return orcamento?.tipoCarga;
  };

  // Group rows by slug
  const groupedData = React.useMemo(() => {
    const groups = {};
    data.forEach((row, originalIndex) => {
      const slug = resolveSlugForRow(row);
      if (!groups[slug]) {
        groups[slug] = [];
      }
      groups[slug].push({ ...row, _originalIndex: originalIndex });
    });
    return groups;
  }, [data]);

  React.useEffect(() => {
    // SomaTotal de todas as coluna16
    let soma = 0;
    data.map((row) => {
      soma += parseFloat(row.coluna16 || 0);
    });
    setSomaTotal(soma);
  }, [data]);

  React.useEffect(() => {
    // Inicializa o data com os itens
    handleChangeFontes();
    if (itens?.data) {
      setRows(itens.data);
    }
    setData(itens?.data || []);
  }, [itens]);

  React.useEffect(() => {
    setIsErrorPrazo(!orcamento.validadeProposta);
    setIsErrorValidadeProposta(!orcamento.prazoEntrega);
    checkIfRowsAreValid(data);
  }, [data, orcamento]);

  const getTipoCarga = (cod) => {
      if (cod === 'esco') return 'ESCO';
      let nomecarga = tiposCargas.find((e) => e.id === cod);
      if (nomecarga === undefined || nomecarga === null){
        nomecarga = tiposServicos.find((f) => f.id === cod);
      }
      return nomecarga ? nomecarga.label : "Desconhecido";
  };

  const formatDateToPtBr = (dateString) => {
    // Verifica se a string contém informações de timezone
    dateString = dateString.substring(0, 10);
    const date = new Date(dateString.includes('T') ? dateString : `${dateString}T00:00:00`);

    // Formata a data para o formato 'dd/mm/yyyy'
    return date.toLocaleDateString('pt-BR', {
      timeZone: 'America/Sao_Paulo', // Garante o fuso horário correto
    });
  };

  const close = () => {
    // reset(defaultValues);
    onClose(true);
  };

  const aprovar2fase = async () => {
    const enviofase2At = new Date();

    startLoading();
    try {
      let getOrcamentos = (
        await api.http.put("/orcamentos/processo/tomada/aprovarpara2fase/" + orcamento?.id
          , {
            enviofase2At: enviofase2At.toISOString().split('T')[0] // Envia no formato 'YYYY-MM-DD'
          }
        )).data;
      onClose(true);
      stopLoading();

    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
    }
  };

  async function salvarTomada(enviar){
    startLoading();
    try {
      await api.http.put("/fornecedores/orcamentos/processo/tomada/alterarvalores/" + orcamento?.id
      , {
          validadeProposta: orcamento.validadeProposta,
          prazoEntrega: orcamento.prazoEntrega,
          observacoes: orcamento.observacoes,
          tomadas: data.map(({ id, coluna14, coluna15, coluna16 }) => ({
            id,
            coluna14,
            coluna15,
            coluna16,
          })),
          respostaFase1At: enviar,
        });
      if(enviar){
        onClose(true);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
    }
  };

  const preencherInfo = (name, chave) => {
    // Localiza o objeto correto com base no 'name'
    const itemSelecionado = dialogoTomadaPreco.find(item => item.name === name);

    if (!itemSelecionado || !itemSelecionado[chave]) return null; // Verifica se existe a chave

    // Retorna o conteúdo para ser renderizado
    return itemSelecionado[chave].map(info => (
      <Grid container key={info.ordem} spacing={2}>
        <Grid item xs={1} className="item-response-color">
          <Typography variant="subtitle2" gutterBottom className='margemtexto'>
            {info.ordem}
          </Typography>
        </Grid>
        <Grid item xs={11} className="item-response">
          <Typography variant="subtitle2" gutterBottom className='margemtexto'>
            {info.detalhe}
          </Typography>
        </Grid>
      </Grid>
    ));
  };

  const handleInputChange = (rowIndex, key, value) => {
    setData((currentData) => {
      const updatedData = currentData.map((row, index) =>
        index === rowIndex ? { ...row, [key]: value } : row
      );
      const row = updatedData[rowIndex];
      const slug = resolveSlugForRow(row);
      const isRowServico = !!tiposServicos.find((f) => f.id === slug);
      const quantidade = isRowServico ? parseFloat(row.coluna14 || 0) : 1;
      const valorUnitario = parseFloat(row.coluna15 || 0);
      row.coluna16 = quantidade * valorUnitario;
      return updatedData;
    });
  };

  const handleChangeFontes = () => {
    // I need to convert the string to a number
    setTotalSumFontes(
      parseFloat(orcamento?.servicosConsultoria) +
      parseFloat(orcamento?.treinamentos) +
      parseFloat(orcamento?.equipamentos) +
      parseFloat(orcamento?.servicosInstalacao) +
      parseFloat(orcamento?.softwares) +
      parseFloat(orcamento?.materiaPrima)
    );
  };

  const checkIfIsEmptyOrNegative = (value) => {
    if (value === "" || parseFloat(value) < 0) {
      return 0;
    }

    return parseFloat(value);
  };

  const checkIfRowsAreValid = (updatedRows) => {
    const hasInvalidRow = updatedRows.some((row) => {
      const slug = resolveSlugForRow(row);
      const isRowServico = !!tiposServicos.find((f) => f.id === slug);
      
      const editableColumns = ["coluna15"];
      if (isRowServico) {
        editableColumns.push("coluna14");
      }

      return editableColumns.some((col) => {
        const v = row[col];
        return v === null || v === undefined || v.toString().trim() === "";
      });
    });

    const hasInvalidOrc = [orcamento.validadeProposta, orcamento.prazoEntrega]
      .some((v) => v === null || v === undefined || v.toString().trim() === "" || v === 0);

    const hasEmptyField = hasInvalidRow || hasInvalidOrc;
    setIsDisabled(hasEmptyField);
  };

  const handleRowChange = (index,field, newValue) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = { ...updatedRows[index], [field]: newValue };
      return updatedRows;
    });
  };

  const adicionarValor = (valor) => {
    // Verifica se o valor é string, substitui a vírgula por ponto e converte para número
    const valorConvertido = typeof valor === 'string'
      ? parseFloat(valor.replace(',', '.'))
      : Number(valor);

    // Atualiza o estado adicionando o valor convertido
    if (!isNaN(valorConvertido)) { // Verifica se é um número válido
      setSomaTotal((prevSoma) => prevSoma + valorConvertido);
    } else {
      console.error('O valor fornecido não é um número válido:', valor);
    }
  };

  // const convertStringToNumber = (value1, value2) => {
  //   // Função que garante a conversão de string para número, substituindo vírgula por ponto
  //   const convert = (str) => {
  //     // Substitui vírgula por ponto e converte para número
  //     const formattedStr = str.replace(',', '.');
  //     console.log("Converte: ", formattedStr);
  //     return parseFloat(formattedStr);
  //   };

  //   console.log("Numero 1: ", value1);
  //   console.log("Numero 2: ", value2);
  //   // Converte os dois valores
  //   const number1 = convert(value1);
  //   const number2 = convert(value2);

  //   const multiplica = (number1 * number2)

  //   // Retorna os números convertidos
  //   return multiplica;
  // };

  // React.useEffect(async () => {
  //   startLoading();
  //   try {
  //     let getOrcamentos = await api.http.get("/orcamentos/processo/tomada/itens/" + orcamento.id).data;
  //     setDados(getOrcamentos);
  //     console.log("getorcamentos: ", getOrcamentos);
  //   } catch (error) {
  //     stopLoading({
  //       message: error.toString(),
  //       severity: "error",
  //     });

  //   };
  // }, [orcamento])

  // console.log("orcamento: ", orcamento);
  //console.log("selectedHeaders:", selectedHeaders);
  // console.log("dados:", itens?.data);

  // const isPastDate = (selectedDate) => {
  //   const today = new Date(); // Data atual
  //   //const selectedDate = new Date(inputDate); // Data selecionada

  //   // Remover o tempo da comparação (apenas ano, mês e dia)
  //   today.setHours(0, 0, 0, 0);
  //   selectedDate.setHours(0, 0, 0, 0);

  //   // Verificar se a data selecionada é anterior à data atual
  //   return (selectedDate < today);
  // };

  const isFutureDate = (timestamp) => {
    // Converte o timestamp para uma data
    const dateToCompare = new Date(timestamp);

    // Pega a data e hora atual
    const currentDate = new Date();

    // Retorna true se o timestamp for maior que a data atual
    return dateToCompare > currentDate;
  };


  return (
    <Dialog open={open} onClose={() => onClose()} fullScreen>
      <DialogTitle>Visualização tomada de preços 1ª Fase</DialogTitle>
      <DialogContent dividers>
        <Box className="title">
          <Typography align="center" variant="subtitle1" className="titleFontColor">
            PROGRAMA POTENCIALIZEE - {getTipoCarga(orcamento?.tipoCarga)}
          </Typography>
        </Box>
        <Box className="title">
          <Typography align="left" variant="subtitle1" className="titleFontColor">
            PEDIDO DE ORÇAMENTO: {orcamento?.id}
          </Typography>
        </Box>
        <Box className="title">
          <Typography align="left" variant="subtitle1" className="titleFontColor">
            DADOS DE IDENTIFICAÇÃO DO SOLICITANTE:
          </Typography>
        </Box>
        <Grid container spacing={0}>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Nome do Especialista Responsável: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.auditorNome}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Email do Especialista Responsável: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.auditorEmail}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Cidade: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.cidade}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">UF: </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.estado}</Typography>
          </Grid>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Validade da proposta </Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            {!isFornecedor ?
              (<Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.validadeProposta} </Typography>) :
              (<TextField
                id="validadeProposta"
                name="validadeProposta"
                type="number"
                inputProps={{ min: 0 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      dias
                    </InputAdornment>
                  ),
                }}
                error={isErrorValidadeProposta}
                helperText={isErrorValidadeProposta ? 'Campo obrigatório' : ''}
                defaultValue={orcamento?.validadeProposta || 0}
                variant="outlined"
                onChange={(e) => {
                  orcamento.validadeProposta = checkIfIsEmptyOrNegative(e.target.value);
                  setIsErrorValidadeProposta(!orcamento.validadeProposta);
                  checkIfRowsAreValid(data);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />)
            }
          </Grid>
        </Grid>

        {Object.entries(groupedData).map(([slug, groupRows]) => {
          const selectedHeaders = tituloTabelaAddTomadaPorCarga[slug] || {};
          const validHeaderKeys = Object.keys(selectedHeaders).filter(key => selectedHeaders[key] !== "");
          const columns = Object.values(selectedHeaders).filter(header => header !== "");

          const isRowServico = !!tiposServicos.find((f) => f.id === slug);

          return (
            <Box key={slug} sx={{ mb: 4 }}>
              {/* Informações adicionais preference info (if carga) */}
              {tiposCargas.find((f) => f.id === slug) && (
                <>
                  <Box className='title'>
                    <Typography variant="h6" gutterBottom className='titleFontColor'>
                      INFORMAÇÕES ADICIONAIS - {getTipoCarga(slug).toUpperCase()} QUE PREFERENCIALMENTE APRESENTEM:
                    </Typography>
                  </Box>
                  <Grid container spacing={0} className="gridTitleContainer" sx={{ mb: 2 }}>
                    {preencherInfo(slug, "infodefault")}
                  </Grid>

                  <Box className='title'>
                    <Typography variant="h6" gutterBottom className='titleFontColor'>
                      INFORMAÇÕES ADICIONAIS QUE DEVEM ESTAR CONTIDAS NA PROPOSTA:
                    </Typography>
                  </Box>
                  <Grid container spacing={0} className="gridTitleContainer" sx={{ mb: 2 }}>
                    {preencherInfo(slug, "infotomada")}
                  </Grid>
                </>
              )}

              <Box className='title'>
                <Typography variant="h6" gutterBottom className='titleFontColor'>
                  INFORMAÇÕES SOBRE {getTipoCarga(slug).toUpperCase()} A SEREM ORÇADAS:
                </Typography>
              </Box>

              <TableContainer component={Paper} sx={{ maxHeight: 400, mb: 2 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((header, index) => (
                        <TableCell key={index} align="center">
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {groupRows.map((row) => {
                      const rowIndex = row._originalIndex;
                      return (
                        <TableRow key={rowIndex}>
                          {validHeaderKeys
                            .sort((a, b) =>
                              a.localeCompare(b, undefined, { numeric: true })
                            )
                            .map((key, colIndex) => {
                              const cellValue =
                                typeof row[key] === "string"
                                  ? row[key].replace(",", ".")
                                  : row[key];

                              if (key === "coluna14" && isRowServico && isFornecedor) {
                                return (
                                  <TableCell
                                    key={colIndex}
                                    align="center"
                                    sx={{ maxWidth: 100, overflow: "hidden" }}
                                  >
                                    <TextField
                                      type="number"
                                      inputProps={{ min: 0 }}
                                      value={row[key] ?? ""}
                                      error={row[key] === "" || row[key] == null}
                                      helperText={row[key] === "" ? "Campo obrigatório" : ""}
                                      variant="outlined"
                                      onChange={(e) => {
                                        handleInputChange(rowIndex, key, e.target.value);
                                      }}
                                    />
                                  </TableCell>
                                );
                              }

                              if (key === "coluna15" && isFornecedor) {
                                return (
                                  <TableCell
                                    key={colIndex}
                                    align="center"
                                    sx={{ maxWidth: 100, overflow: "hidden" }}
                                  >
                                    <TextField
                                      type="number"
                                      inputProps={{ min: 0 }}
                                      value={row[key] ?? ""}
                                      error={row[key] === "" || row[key] == null}
                                      helperText={row[key] === "" ? "Campo obrigatório" : ""}
                                      variant="outlined"
                                      onChange={(event) => {
                                        handleInputChange(rowIndex, key, event.target.value);
                                      }}
                                      autoFocus
                                    />
                                  </TableCell>
                                );
                              }

                              return (
                                <TableCell key={colIndex} align="center">
                                  {(key === "coluna15" || key === "coluna16")
                                    ? formatCurrency(cellValue || 0)
                                    : cellValue}
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          );
        })}

        {/* Fornecedor Information Section */}
        <Box className='title'>
          <Typography variant="h6" gutterBottom className='titleFontColor'>
            INFORMAÇÕES SOBRE O FORNECEDOR:
          </Typography>
        </Box>

        <Grid container spacing={0} sx={{ mb: 4 }}>
          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Fornecedor:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.fornecedorNome}</Typography>
          </Grid>

          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Prazo Máximo para retorno:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.finishedAt ? formatDateToPtBr(orcamento.finishedAt) : ""}</Typography>
          </Grid>

          <Grid item xs={4} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">Data Retorno:</Typography>
          </Grid>
          <Grid item xs={8} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='margemtexto'> {orcamento?.respostafase1At ? formatDateToPtBr(orcamento.respostafase1At) : ""}</Typography>
          </Grid>
        </Grid>

        {isFornecedor && prazoEncerrado && (
          <Typography color="error" sx={{ mb: 2, fontWeight: 600 }}>
            O prazo para responder esta tomada foi encerrado.
          </Typography>
        )}

        <Grid container spacing={0}>
          <Grid item xs={3} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">
              {orcamento?.tipoCarga === 'esco' ? 'PRAZO PARA ENTREGA / EXECUÇÃO:' : (tiposServicos.find((f) => f.id === orcamento.tipoCarga) ? 'PRAZO PARA PRESTAÇÃO DE SERVIÇO:' : 'PRAZO PARA ENVIO DO EQUIPAMENTO:')}
            </Typography>
          </Grid>
          <Grid item xs={6} className="item-response">
            {!isFornecedor ? (
              <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.prazoEntrega} DIAS</Typography>) : (
              <TextField
                id="prazoEntrega"
                name="prazoEntrega"
                type="number"
                error={isErrorPrazo}
                helperText={isErrorPrazo ? 'Campo obrigatório' : ''}
                defaultValue={orcamento?.prazoEntrega || 0}
                variant="outlined"
                inputProps={{ min: 0 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      dias
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  orcamento.prazoEntrega = checkIfIsEmptyOrNegative(e.target.value);
                  setIsErrorPrazo(!orcamento.prazoEntrega);
                  checkIfRowsAreValid(data);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={3} className="item-response">
            <Typography variant="subtitle2" gutterBottom className='gridItemTitleResponseright'>{formatCurrency(somaTotal)}</Typography>
          </Grid>
          <Grid item xs={3} className="item-response-color">
            <Typography variant="subtitle2" gutterBottom className="titleFontColor">CONDIÇÕES DE PAGAMENTO: </Typography>
          </Grid>
          <Grid item xs={9} className="item-response">
            {/* <Typography variant="subtitle2" gutterBottom className='margemtexto'>{orcamento?.observacoes}</Typography> */}
            {isFornecedor ?
              <TextField
                sx={{ width: '100%' }}
                id="outlined-basic"
                variant="outlined"
                defaultValue={orcamento?.observacoes || ""}
                onChange={(e) => {orcamento.observacoes = e.target.value}}
              />
              : orcamento?.observacoes}
          </Grid>
        </Grid>
        {!isFornecedor && (
          <Button variant="outlined"
          sx={{ marginTop: "1rem" }}
          onClick={aprovar2fase}
          disabled={!orcamento.respostafase1At && isFutureDate(orcamento?.finishedAt)}>Aprovar 2ª fase</Button>
        )}

      </DialogContent>
      <DialogActions>
        {loading > 0 && (
          <CircularProgress
            size={30}
            sx={{
              position: "absolute",
              left: 25,
              bottom: 12,
            }}
          />
        )}
        {isFornecedor &&
          <Button
            disabled={prazoEncerrado}
            onClick={() => salvarTomada(false)}>Salvar</Button>
        }
        {isFornecedor &&
          <Button color="secondary"
            sx={{ marginLeft: "1rem" }}
            disabled={isDisabled || prazoEncerrado}
            onClick={() => salvarTomada(true)}>Enviar</Button>
        }
        <Button color="inherit" onClick={() => close()}>
          FECHAR
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default DialogoAcompanhaOrcamentosFaseOne;
